import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Page } from './model/page';
import { UtilisateurDto, UtilisateurDtoMapper } from './dto/utilisateur-dto';
import { User } from './model/user';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private http = inject(HttpClient);
  private apiBaseUrl = environment.apiUrls.courseGrid;

  getUser(email: string): Observable<User[]> {
    const params = new HttpParams()
      .set('email', email)
      .set('pageSize', '1000');
    return this.http.get<Page<UtilisateurDto>>(`${this.apiBaseUrl}/utilisateurs`, { params }).pipe(
      map((dto) => dto.items.map((dto) => UtilisateurDtoMapper.toDomain(dto)))
    );
  }
}
